<template>
<kt-panel>
    <div class="accordion accordion-toggle-arrow" id="userFilter">
        <div class="card" style="overflow:inherit">
            <div class="card-header bg-transparent" id="headingOne">
                <div class="card-title collapsed" data-toggle="collapse" 
                    data-target="#filterForm"
                    aria-controls="filterForm">
                    {{ $t('label.search') }}
                </div>
            </div>
            <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                <div class="card-body">
                    <form @submit.prevent="action($event, query)">
                        <kt-form-section>
                            <kt-form-row>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="full_name">
                                            {{ $t('label.user_full_name') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="full_name"
                                                dir="ltr"
                                                name="full_name"
                                                id="full_name"
                                                v-model="query.full_name"
                                        />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="status">
                                            {{ $t('label.gateway_status') }}
                                        </kt-form-label>
                                        <kt-form-select
                                                size="3"
                                                id="status"
                                                class="form-control"
                                                name="status"
                                                v-model="query.status"
                                        >
                                            <option value="">
                                                {{$t('selectpicker.nothing_selected')}}
                                            </option>
                                            <option
                                                    v-bind:key="index"
                                                    v-for="(gateway_status, index) in depositStatus"
                                                    v-bind:value="gateway_status"
                                                    :selected="query.gateway_status === gateway_status"
                                            >
                                                {{ depositStatusStr.get(gateway_status) }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                            </kt-form-row>
                        </kt-form-section>
                        <kt-form-section>
                            <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                        </kt-form-section>
                    </form>
                </div>
            </div>
        </div>
    </div>
</kt-panel>
</template>

<script>
import { depositStatus,depositStatusStr } from '@/constants/deposit'
import $ from "jquery";
import { i18n } from '@/plugins/i18n'

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        }
    },
    mounted() {
        this.afterDispatch()
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
    },
    data() {
        return {
            depositStatus,
            depositStatusStr,
            query: {
                status: null
            },
        }
    }
}
</script>

<style>

</style>